module.exports = __webpack_public_path__ + "static/media/gameLose.df6d48b1.mp3";